// removed by extract-text-webpack-plugin
module.exports = {"grat-price":"app-components-receipt-refunds-RefundBreakdownModal-Gratuity-__Gratuity___2ApPm","gratuity":"app-components-receipt-refunds-RefundBreakdownModal-Gratuity-__Gratuity___3Hk8V","list-gratuity":"app-components-receipt-refunds-RefundBreakdownModal-Gratuity-__Gratuity___2NQq7"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/refunds/RefundBreakdownModal/Gratuity/Gratuity.css
// module id = 2243
// module chunks = 0